/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Gap_Too_SmallInputs */



/**
* | output |
* | --- |
* | "Frame gap too small" |
*
* @param {Qc_Fix_Gap_Too_SmallInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_gap_too_small = /** @type {((inputs?: Qc_Fix_Gap_Too_SmallInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Gap_Too_SmallInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Écart d'images trop petit")
	if (locale === "de") return /** @type {LocalizedString} */ ("Frame-Abstand zu klein")
	if (locale === "it") return /** @type {LocalizedString} */ ("Intervallo di fotogrammi troppo piccolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слишком маленький интервал между кадрами")
	if (locale === "es") return /** @type {LocalizedString} */ ("Separación de fotogramas demasiado pequeña")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帧间隔过小")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレーム間隔が狭すぎます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़्रेम अंतराल बहुत छोटा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Intervalo de fotogramas demasiado pequeno")
	return /** @type {LocalizedString} */ ("Frame gap too small")
});